<ngx-spinner></ngx-spinner>
<router-outlet>
  <app-spinner></app-spinner>
</router-outlet>
